import { lazy, Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import ScrollToTop from "./components/ScrollToTop";
import CookieBanner from "./components/CookieBanner";

const CityPage = lazy(() => import("./pages/CityPage"));
const MentionsLegales = lazy(() => import("./pages/MentionsLegales"));
const GestionPage = lazy(() => import("./pages/GestionPage"));
const BlogIndex = lazy(() => import("./pages/BlogIndex"));
const BlogArticle = lazy(() => import("./pages/BlogArticle"));
const NotFound = lazy(() => import("./pages/NotFound"));
const DevisPage = lazy(() => import("./pages/DevisPage"));
const PeintureInterieurePage = lazy(() => import("./pages/PeintureInterieurePage"));
const PeintresSensPage = lazy(() => import("./pages/PeintresSensPage"));
const DemoussageToiturePage = lazy(() => import("./pages/DemoussageToiturePage"));
const TraitementHydrofugePage = lazy(() => import("./pages/TraitementHydrofugePage"));
const NettoyageHautePressionPage = lazy(() => import("./pages/NettoyageHautePressionPage"));

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <Suspense fallback={<div className="min-h-screen bg-background" />}>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/renovation/:slug" element={<CityPage />} />
              <Route path="/blog" element={<BlogIndex />} />
              <Route path="/blog/:slug" element={<BlogArticle />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/gestion" element={<GestionPage />} />
              <Route path="/devis" element={<DevisPage />} />
              <Route path="/peinture-interieure" element={<PeintureInterieurePage />} />
              <Route path="/peintres-sens" element={<PeintresSensPage />} />
              <Route path="/demoussage-toiture-sens" element={<DemoussageToiturePage />} />
              <Route path="/traitement-hydrofuge-sens" element={<TraitementHydrofugePage />} />
              <Route path="/nettoyage-haute-pression-sens" element={<NettoyageHautePressionPage />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
        <CookieBanner />
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
